/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.landscape\":\"Sun and mountains\"}");